import axios from 'axios';
import { SERVICE_BASE_URI } from '../config/BVConstants';
import { clearState } from '../context/reducers/userReducer';
import store from '../context/store';
import { getLocalAccessToken, getLocalRefreshToken, clearTokenLogout } from '../utils/commonUtil';

let isRefreshing = false; // Flag to check if a token refresh is in progress
let refreshAndRetryQueue = []; // Queue to hold failed requests

async function refreshToken(token) {
  return fetchDataPostReq("/auth/refreshtoken", { refreshToken: token });
}

const instance = axios.create({
  baseURL: SERVICE_BASE_URI,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
  },
});

instance.interceptors.request.use(
  async (config) => {
      const token = await getLocalAccessToken();
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

instance.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalConfig = error.config;
    if (error.response) {
      if (error.response.status === 401 && !originalConfig._retry) {
        if (!isRefreshing) {
          originalConfig._retry = true;
          isRefreshing = true;
            try {
            const rs = await refreshToken(await getLocalRefreshToken());
              if (rs) {
                error.config.headers["Authorization"] = `Bearer ${await getLocalAccessToken()}`;
                
                // Retry all requests in the queue with the new token
                refreshAndRetryQueue.forEach(({ config, resolve, reject }) => {
                  instance
                    .request(config)
                    .then((response) => resolve(response))
                    .catch((err) => reject(err));
                });

                // Clear the queue
                refreshAndRetryQueue.length = 0;

                // Retry the original request
                return instance(originalConfig);
              }
            } catch (refreshError) {
              store.dispatch(clearState());
              await clearTokenLogout();
            } finally {
              isRefreshing = false;
            }
          }
          // Add the original request to the queue
          return new Promise((resolve, reject) => {
            refreshAndRetryQueue.push({ config: originalConfig, resolve, reject });
          });
        }
       if (error.response.status === 403 && error.response.data) {
        store.dispatch(clearState());
        await clearTokenLogout();
        return Promise.reject(error.response.data);
      }
    }
    return Promise.reject(error);
  }
);

export async function fetchDataGetReq(url) {
  return await instance
    .get(url)
    .then((res) => {
      return res.data;
    })
    .catch((error) => {
      throw error;
    });
}

export async function fetchDataPostReq(url, data, headers) {
  console.log(data)
  return await instance
    .post(url, data, { headers: { ...instance.defaults.headers.common, ...headers } })
    .then((res) => {
      console.log(res)
      return res.data;
    }).catch((error) => {
      throw error;
    });
}

export async function fetchDataPutReq(url, data) {
  return await instance
    .put(url, data)
    .then((res) => {
      return res.data;
    })
    .catch((error) => {
      throw error;
    });
}
